import {
  DeleteOutlined,
  EditOutlined,
  FieldTimeOutlined
} from '@ant-design/icons'
import {
  Button,
  Empty,
  Form,
  message,
  Space,
  Tooltip
} from 'antd'
import dayjs from 'dayjs'
import { debounce, find } from 'lodash'
import get from 'lodash.get'
import React, { useEffect, useMemo, useState } from 'react'
import { v4 as uuidv4 } from 'uuid'; // Import uuid
import {
  convertPriceToNumber,
  formatCurrencyLabel,
  getLabelByValue,
  hasPermission,
  removeNullUndefined
} from '../../config-func'
import { PAGE_SIZE_OPTIONS } from '../../configData'
import { departmentSearch } from '../../services/cmsservice'
import {
  addressSearch,
  addressSearchAll,
  getListStaff,
  getListUserDepartment,
  getUserManagePost,
  listHistory,
  listUserPost,
  postAdd,
  postCommunityDetail,
  postDelete,
  postSearch,
  postUpdate,
  projectSearch,
  upLoadImage
} from '../../services/postservice'
import Card from '../Card'
import { columnLabel } from '../RequestInternal/configs'
import ModalCustom from '../common/Modal/ModalCustom'
import ModalConfirm, { showConfirm } from '../common/ModalConfirm/ModalConfirm'
import openNotification from '../common/Notification/openNotification '
import PhoneVisibilityCell from '../common/PhoneVisibilityCell'
import ExportButton from '../common/ExportButton'
import TableField from '../common/Table/TableField'
import FilterForm from './FilterForm'
import FormPost from './FormPost2'
import {
  APARTMENT_TYPE,
  BALCONY_DIRECTION,
  BedroomNumber,
  FURNITURE_TYPE,
  getSubProductType,
  LabelType,
  POLICY_DOCUMENT,
  PROCCESS_TRANFER,
  ProductType,
  SECURITY_TYPE,
  status,
  statusList
} from './configs'
import { breakingSearch } from '../../services/breaking-news-service'
import HistoryModal from './HistoryModal'
import Note from './Note'
// const { TextArea } = Input
import Loading from '../Loading';

// const { Option } = Select
export const ACTION_MODE = {
  VIEW: 'VIEW',
  ADD: 'ADD',
  UPDATE: 'UPDATE'
}
// const { TabPane } = Tabs

const BreakingNews = () => {
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [pageSize, setPageSize] = useState(10) // Kích thước trang mặc định
  // const [page, setCurrentPage] = useState(1) // Trang hiện tại
  const [mode, setMode] = useState(ACTION_MODE.VIEW)
  const [form] = Form.useForm()
  const [formSearch] = Form.useForm()
  const [listDepartment, setListDepartment] = useState([])
  // const [checkedKeys, setCheckedKeys] = useState(new Set())
  const [data, setData] = useState([])
  // Form thêm mới
  const [loading, setLoading] = useState(false)
  const [postType, setPostType] = useState('')
  const [typeRealEstate, setTypeRealEstate] = useState([])
  const [pagination, setPagination] = useState({
    current: 1, // Trang hiện tại
    pageSize: 10 // Số bản ghi mỗi trang
  })
  const [isText, setIsText] = useState(false)
  // get arr select
  const [listUser, setListUser] = useState([])
  const [listProject, setListProject] = useState([])
  const [cities, setCities] = useState([])
  const [districts, setDistricts] = useState([])
  const [towns, setTowns] = useState([])
  const [listUserDepartment, setListUserDepartment] = useState([])
  const user_role = localStorage.getItem('user_role')
  // const [productCity, setProductCity] = useState('')
  // const [productDistrict, setProductDistrict] = useState('')
  // const [currentRow, setCurrentRow] = useState({
  //   city_code: '',
  //   district_code: ''
  // })

  // Upload ảnh
  const [fileList, setFileList] = useState([])
  const [fileListVideo, setFileListVideo] = useState([])
  const [fileList360, setFileList360] = useState([])
  const [previewVisible, setPreviewVisible] = useState(false)
  const [previewImage, setPreviewImage] = useState()
  const [previewTitle, setPreviewTitle] = useState()
  const [isModalNote, setIsModalNote] = useState(false)
  const [isModalImportOpen, setIsModalImportOpen] = useState(false)
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [isModalManagerRequest, setIsModalManagerRequest] = useState(false)

  const [recordId, setRecordId] = useState()
  const [isOpenCall, setIsOpenCall] = useState(false)

  const [citiesAll, setCitiesAll] = useState([])
  const [districtsAll, setDistrictsAll] = useState([])
  const [townsAll, setTownsAll] = useState([])


  const getUserDepartment = async (id) => {
    let page = 1
    let pageSize = 1000

    try {
      const body = {
        page,
        pageSize,
        department_id: id
      }
      const res = await getListUserDepartment(body) // Assuming roleSearch is an API function
      if (res && res.data.list) {
        const result = res?.data?.list.map((item) => ({
          ...item,
          value: item.id,
          label: item.name
        }))
        setListUserDepartment(result) // Update the state with the list of roles
      } else {
        // Handle the case where the response is unexpected or empty
        console.error('No data found or invalid response')
        setListUserDepartment([]) // Optionally, reset the list to an empty array
      }
    } catch (err) {
      // Handle the error gracefully
      openNotification('error', err?.response?.data?.message || 'Đã có lỗi xảy ra')
      // You might want to show a notification or alert to the user here
      setListUserDepartment([]) // Optionally, reset the list to an empty array
    }
  }

  useEffect(() => {
    const department_id = localStorage.getItem('department_id')
    if (user_role === 'ADMIN') {
      getUserDepartment('')
    } else {
      getUserDepartment(department_id)
    }
  }, [])

  // Danh sách thành phố
  const getListCitiesAll = async () => {
    try {
      const res = await addressSearch('', 'city')
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.code,
        label: item.name
      }))

      setCitiesAll(result)
    } catch (err) {
      openNotification('error', err?.response?.data?.message || 'Đã có lỗi xảy ra')
    }
  }

  // Danh sách quận huyện
  const getListDistrictsAll = async () => {
    try {
      const res = await addressSearchAll('district')
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.code,
        label: item.name
      }))

      setDistrictsAll(result)
    } catch (err) {
      openNotification('error', err?.response?.data?.message || 'Đã có lỗi xảy ra')
    }
  }

  // Danh sách phường xã
  const getListTownsAll = async () => {
    try {
      const res = await addressSearchAll('town')
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.code,
        label: item.name
      }))

      setTownsAll(result)
    } catch (err) {
      openNotification('error', err?.response?.data?.message || 'Đã có lỗi xảy ra')
    }
  }

  useEffect(() => {
    getListCitiesAll()
    getListDistrictsAll()
    getListTownsAll()
  }, [])
  // Lấy tên quản lý tin theo id bản ghi

  const [listPostUser, setListPostUser] = useState([])
  const getListUserPost = async (postId) => {
    try {
      const res = await listUserPost(postId)
      if (res?.data) {
        console.log('res?.data', res?.data)
        // setListPostUser(res?.data?.list)
      }
    } catch (err) {
      openNotification('error', 'Đã có lỗi xảy ra')
    } finally {
    }
  }
  // Columns for Table
  const initialColumns = [
    {
      title: 'STT',
      dataIndex: 'stt',
      key: 'stt',
      fixed: 'left',
      width: 60,
      align: 'center',
      render: (_, __, index) =>
        (pagination.current - 1) * pagination.pageSize + index + 1
    },
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 60,
      // render: (_, __, index) => (page - 1) * pageSize + index + 1
    },
    {
      title: 'Tên khách hàng',
      dataIndex: 'customer_name',
      key: 'customer_name',
      width: 150,
      render: (_, record) => (
        <span>
          {record?.customer_name ? record?.customer_name : record?.user_info?.name}
        </span>
      )
    },
    {
      title: 'Số điện thoại',
      dataIndex: 'customer_phone_number',
      key: 'customer_phone_number',
      width: 150,
      render: (_, record) => (
        <PhoneVisibilityCell
          value={
            record?.customer_phone_number
              ? record?.customer_phone_number
              : record?.user_info?.phone
          }
          postId={record?.id}
        />
      )
    },
    {
      title: 'Xác thực định danh',
      dataIndex: 'type_user',
      key: 'type_user',
      width: 170,
      render: (_, record) => <span>{record.type_user == '0' ? 'Khách hàng' : record.type_user == '1' ? 'Môi giới bất động sản' : ""}</span>
    },
    {
      title: 'Sàn',
      dataIndex: 'department_id',
      key: 'department_id',
      width: 150,
      render: (_, record, index) => {
        const name = listDepartment.find(
          (n) => n.id === record.department_id
        )?.name
        return <span>{name}</span>
      }
    },
    {
      title: 'Quản lý tin',
      dataIndex: 'manager_post_id',
      key: 'manager_post_id',
      width: 150,
      // render: (text, record) => {
      //   const userIds = record.post_manager_info?.map(
      //     (post) => post.manager_post_id
      //   )

      //   const names = listUserDepartment
      //     .filter((user) => userIds.includes(user.id))
      //     .map((user) => user.name)
      //     .join(', ')
      //   return <>{names}</>
      // }
    },
    {
      title: 'Nhu cầu',
      dataIndex: 'label',
      key: 'label',
      width: 100,
      render: (value) => {
        const nhuCau = columnLabel.find((item) => item.value === value)
        return nhuCau ? nhuCau.label : '' // Nếu không tìm thấy, hiển thị "-"
      }
    },
    {
      title: 'Loại BĐS',
      dataIndex: 'post_type',
      key: 'post_type',
      width: 150,
      render: (_, record) => (
        <span>
          {ProductType.find((n) => n.value === record.post_type)?.label || ''}
        </span>
      )
    },
    {
      title: 'Loại hình BĐS',
      dataIndex: 'type_real_estate',
      key: 'type_real_estate',
      width: 150,
      render: (_, record) => (
        <span>{getLabelByValue(record.type_real_estate)}</span>
      )
    },
    // {
    //   title: 'Diện tích (m2)',
    //   dataIndex: 'acreage',
    //   key: 'acreage',
    //   width: 150,
    // },
    // {
    //   title: 'Mặt tiền (m)',
    //   dataIndex: 'area_outside',
    //   key: 'area_outside',
    //   width: 150,
    // },
    {
      title: 'Dự án',
      dataIndex: 'project_id',
      key: 'project_id',
      width: 200,
      render: (_, record) => (
        <span>
          {listProject.find((n) => n.id === record.project_id)?.project_name ||
            ''}
        </span>
      )
    },
    {
      title: 'Số địa chỉ',
      dataIndex: 'alley',
      key: 'alley',
      width: 150,
    },
    {
      title: 'Mã căn hộ',
      dataIndex: 'apartment_code',
      key: 'apartment_code',
      width: 120,
    },
    {
      title: 'Tòa/Khu',
      dataIndex: 'building',
      key: 'building',
      width: 100,
    },
    {
      title: 'Tầng/Dãy',
      dataIndex: 'floor',
      key: 'floor',
      width: 80,
    },
    {
      title: 'Số căn',
      dataIndex: 'number_of_rooms',
      key: 'number_of_rooms',
      width: 80,
    },
    {
      title: 'Số phòng ngủ',
      dataIndex: 'number_of_bedrooms',
      key: 'number_of_bedrooms',
      width: 130,
    },
    {
      title: 'Số WC',
      dataIndex: 'number_of_wc',
      key: 'number_of_wc',
      width: 80,
    },
    {
      title: 'Diện tích (m2)',
      dataIndex: 'acreage',
      key: 'acreage',
      width: 130,
    },
    {
      title: 'Mặt tiền (m)',
      dataIndex: 'area_outside',
      key: 'area_outside',
      width: 130,
    },
    {
      title: 'Vị trí',
      dataIndex: 'apartment_location',
      key: 'apartment_location',
      width: 120,
      render: (_, record) => (
        <span>
          {APARTMENT_TYPE.find((n) => n.value === record.apartment_location)
            ?.label || record.apartment_location}
        </span>
      )
    },
    {
      title: 'Hướng',
      dataIndex: 'direction',
      key: 'direction',
      width: 120,
      render: (_, record) => (
        <span>
          {BALCONY_DIRECTION.find((n) => n.value === record.direction)?.label ||
            ''}
        </span>
      )
    },
    {
      title: 'Nội thất',
      dataIndex: 'furniture',
      key: 'furniture',
      width: 120,
      render: (_, record) => (
        <span>
          {FURNITURE_TYPE.find((n) => n.value === record.furniture)?.label ||
            ''}
        </span>
      )
    },
    {
      title: 'Giấy tờ pháp lý',
      dataIndex: 'legal',
      key: 'legal',
      width: 150,
      render: (_, record) => (
        <span>
          {POLICY_DOCUMENT.find((n) => n.value === record.legal)?.label ||
            ''}
        </span>
      )
    },
    {
      title: 'Phí giao dịch',
      dataIndex: 'procedure',
      key: 'procedure',
      width: 150,
      render: (_, record) => (
        <span>
          {PROCCESS_TRANFER.find((n) => n.value === record.procedure)?.label ||
            ''}
        </span>
      )
    },

    {
      title: 'Tài chính/Giá',
      dataIndex: 'price',
      key: 'price',
      width: 80,
      render: (_, record) => <span>{formatCurrencyLabel(record.price)}</span>
    },
    {
      title: 'Phí môi giới',
      dataIndex: 'cost',
      key: 'cost',
      width: 120,
      render: (_, record) => <span>{formatCurrencyLabel(record.cost)}</span>
    },
  
    {
      title: 'Hiện trạng',
      dataIndex: 'status',
      key: 'status',
      width: 120,
      render: (_, record) => (
        <span>
          {status.find((n) => n.value === record.status)?.label || ''}
        </span>
      )
    },
    {
      title: 'Trạng thái',
      dataIndex: 'processing_status',
      key: 'processing_status',
      width: 150,
      render: (_, record) => (
        <span>
          {statusList.find((n) => n.value === record.processing_status)?.label || ''}
        </span>
      )
    },
     {
      title: 'Bảo mật thông tin',
      dataIndex: 'security',
      key: 'security',
      width: 170,
      render: (_, record) => (
        <span>
          {SECURITY_TYPE.find((n) => n.value === record.security)?.label || ''}
        </span>
      )
    },  

    {
      title: 'Tỉnh/Thành phố',
      dataIndex: 'city_code',
      key: 'city_code',
      width: 150,
      render: (_, record) => <span>{record?.city_info?.name || 'Đang xác minh'}</span>
      // render: (_, record) => (
      //   <span>
      //     {cities.find((n) => n.code === record.city_code)?.name || ''}
      //   </span>
      // )
    },
    {
      title: 'Quận/Huyện',
      dataIndex: 'district_code',
      key: 'district_code',
      width: 120,
      render: (_, record) => <span>{record?.district_info?.name || 'Đang xác minh'}</span>
    },
    {
      title: 'Phường/Xã',
      dataIndex: 'town_code',
      key: 'town_code',
      width: 150,
      render: (_, record) => <span>{record?.town_info?.name || 'Đang xác minh'}</span>
    },

    {
      title: 'Đường phố',
      dataIndex: 'street',
      key: 'street',
      width: 150,
    },
    {
      title: 'Mô tả',
      dataIndex: 'description',
      key: 'description',
      width: 120,
    },
    
    
    {
      title: 'Thời gian đăng',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 150,
      render: (_, record) => (
        <span>
          {record?.created_at
            ? dayjs.unix(record?.created_at).format('DD/MM/YYYY')
            : ''}
        </span>
      )
    },
    {
      title: 'Thời gian cập nhật',
      dataIndex: 'updated_at',
      key: 'updated_at',
      width: 170,
      render: (_, record) => (
        <span>
          {record?.updated_at
            ? dayjs.unix(record?.updated_at).format('DD/MM/YYYY')
            : ''}
        </span>
      )
    },

    {
      title: 'Hành động',
      key: 'status',
      fixed: 'right',
      width: 150,
      render: (_, record) => {
        return (
          <Space size="small">
            {hasPermission('P79.2', permissions) && (
            <Tooltip title="Chỉnh sửa">
              <Button
                style={{ width: 32 }}
                icon={<EditOutlined />}
                onClick={() => {
                  setMode(ACTION_MODE.UPDATE)
                  getDetailPost(record.id)
                }}
              />
            </Tooltip>
            )}
            {hasPermission('P79.5', permissions) && (
              <Tooltip title="Xem lịch sử">
                <Button
                  onClick={() => {
                    setRecordId(record.id)
                    setIsOpenCall(true)
                  }}
                >
                  <FieldTimeOutlined />
                  Xem lịch sử
                </Button>
              </Tooltip>
             )}
            {hasPermission('P79.4', permissions) && (
              <Tooltip title="Xem Note">
                <Button
                  onClick={() => {
                    // setMode(ACTION_MODE.UPDATE)
                    // getDetailRequest(record.id)
                    setRecordId(record.id)
                    setIsModalNote(true)
                  }}
                >
                  <FieldTimeOutlined />
                  Note
                </Button>
              </Tooltip>
            )}
            {record.status !== 'inactive' && hasPermission('P79.3', permissions) && (
              <Tooltip title="Xóa">
                <Button
                  style={{ width: 32 }}
                  icon={<DeleteOutlined style={{ color: 'red' }} />}
                  onClick={() =>
                    showConfirm({
                      title: 'Xác nhận xoá',
                      content: (
                        <div>
                          Bạn có chắc chắn muốn xoá bài đăng
                          <b> {record.title}</b> không?
                        </div>
                      ),
                      onOk: () => deleteRequest([record.id])
                    })
                  }
                />
              </Tooltip>
            )}
          </Space>
        )
      }
    }
  ]

  // Render loại hình BĐS theo loại BĐS
  const onChangePostType = (e) => {
    const type = getSubProductType(e)

    form.setFields([
      {
        name: 'project_id',
        errors: [],
      },
    ]);
    // const formattedArray = type?.map((item) => ({ value: item, label: item }))
    form.setFieldsValue({
      type_real_estate: null
    })
    setTypeRealEstate(type)
    setPostType(e)
  }

  // Lấy danh sách post
  const getListPost = async (values = {}) => {
    setLoading(true)

    const value = removeNullUndefined(values)
    try {
      const body = { ...value, pageSize: pagination.pageSize }
      const res = await breakingSearch(body)

      setData(res.data)
    } catch (err) {
      openNotification('error', err?.response?.data?.message || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }

  useMemo(() => {
    if (pagination.current && pagination.pageSize) {
      const value = formSearch.getFieldsValue()
      getListPost({
        ...value,
        page: pagination.current,
        pageSize: pagination.pageSize
      })
    }
  }, [pagination.current, pagination.pageSize])

  // Khi thay đổi trang
  const handlePageChange = (current, pageSize) => {
    setPagination((prev) => ({
      ...prev,
      current: prev.pageSize !== pageSize ? 1 : current, // Nếu đổi pageSize thì reset current
      pageSize
    }))
  }

  const handleSearch = debounce((values) => {
    console.log('Tìm kiếm với:', values)
  }, 300)
  // Thêm sửa post
  const handleSave = async () => {
    setLoading(true)
    try {

      const user_name = localStorage.getItem('user_name')
      const user_phone = localStorage.getItem('user_phone')
      // Validate các trường trong form
      const values = await form.validateFields()
      // Kiểm tra nếu cả hai giá trị đều tồn tại
      // const img_360 = values.image_360.map((item) => ({
      //   type: 'IMAGE360',
      //   link: item.url
      // }))

      let img_360 = []

      if (isText) {
        img_360 = values.image_360.map((item) => ({
          type: 'IMAGE360',
          link: item.url
        }))
      }else {
        img_360 = values.img360?.fileList?.map((item) => ({
        type: 'IMAGE360',
        link: item.response?.[0]?.link
      }))
      }

      
      const fileImg = fileList.map((item) => ({
        link: item.response?.[0]?.link || item.url, // Lấy link từ response hoặc url
        type: 'IMAGE'
      }))
      const fileVideo = fileListVideo.map((item) => ({
        link: item.response?.[0]?.link || item.url, // Lấy link từ response hoặc url
        type: 'VIDEO'
      }))

      const { id, video_urls, image_360, img360, manager_post_id, ...data } =
        values
      let body = {}
      body = {
        ...data,
        from: 3,
        files:[...fileImg, ...fileVideo, ...(img_360 || [])] ,
        number_of_rooms:
          values.number_of_rooms && values.number_of_rooms.toString(),
          price: values.price ? convertPriceToNumber(values.price?.toString()) : 0,
          cost: values.cost ? convertPriceToNumber(values.cost?.toString()) : 0,
          customer_name: user_name,
          customer_phone_number: user_phone,
      }

      if(!values.price || values.price === 0) {
        delete body.price
      }
      if(!values.cost || values.cost === 0) {
        delete body.cost
      }
      const res =
        mode == ACTION_MODE.ADD
          ? await postAdd(body)
          : await postUpdate(body, id)

          openNotification(
        'success',
        mode == ACTION_MODE.ADD
          ? 'Tạo tin thành công'
          : 'Cập nhật tin thành công'
      )
      getListPost()
      form.resetFields()
      setIsModalOpen(false)
      setFileList([])
      setFileList360([])
      setFileListVideo([])
    } catch (err) {
      // Lấy danh sách lỗi từ API
      const errors = get(err, 'response.data.message', [])

      // Xử lý lỗi nếu là mảng
      const errorMessages = Array.isArray(errors)
        ? errors.map((error) => error.message).join('\n')
        : errors // Nếu không phải mảng, lấy trực tiếp

      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }

  // Xóa tin
  const deleteRequest = async (ids) => {
    setLoading(true)
    try {
      const deId = localStorage.getItem('department_id')
      // Lọc ra các key có giá trị true và đưa vào mảng
      const body = {
        ids,
        from: 3,
        type: 15,
        department_id: deId
      }
      const res = await postDelete(body)
      getListPost()
      setSelectedRowKeys([])
      openNotification('success', res.message)
    } catch (err) {
      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }
  // Chi tiết quyền
  const getDetailPost = async (id) => {
    setLoading(true)
    const body = {
      from: 3
    }
    try {
      const res = await postCommunityDetail(body, id) // Assuming roleSearch is an API function

      if (res && res.data) {
        setIsModalOpen(true)
        const values = res.data
        form.setFieldsValue({
          ...values
        })
        // getUserAll({ department: values.department_id })
        // onChangePostType(values.post_type)
        getListDistricts(values.city_code)
        getListTowns(values.district_code)
        const type = getSubProductType(values.post_type)
        // const formattedArray = type?.map((item) => ({ value: item, label: item }))
        setTypeRealEstate(type)
        setPostType(values.post_type)
        // getUserManage(values.department_id)
        // getUserAll(values.department_id)
        // const fileList = values?.post_files?.map((item, index) => ({
        //   uid: uuidv4(), // Tạo ID duy nhất bằng uuid
        //   url: item.link, // Link ảnh từ API,
        //   name: uuidv4(),
        //   status: 'done',
        //   thumbUrl: item.link
        // }))

        // Hàm để format dữ liệu
        const formatFiles = (fileList) =>
          fileList.map((item) => ({
            uid: uuidv4(), // ID duy nhất
            url: item.link, // Link ảnh/video từ API
            name: uuidv4(), // Tên file ngẫu nhiên
            status: 'done' // Đánh dấu đã tải lên thành công
            // thumbUrl: item.link // Ảnh thu nhỏ
            // type: item.type // IMAGE hoặc VIDEO
          }))

        const images = formatFiles(
          values?.post_files.filter((file) => file.type === 'IMAGE')
        )

        const videos = formatFiles(
          values?.post_files.filter((file) => file.type === 'VIDEO')
        )
        const others = formatFiles(
          values?.post_files.filter(
            (file) => file.type !== 'IMAGE' && file.type !== 'VIDEO'
          )
        )

        setFileList(images)
        setFileListVideo(videos)
        setFileList360(others)
        form.setFieldsValue({ image_360: others })
      } else {
        console.error('No data found or invalid response')
      }
    } catch (err) {
      openNotification('error', err?.response?.data?.message || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }

  // lấy thông tin quản lý tin
  const getUserManage = async (id) => {
    try {
      const res = await getUserManagePost(id) // Assuming roleSearch is an API function

      if (res && res.data) {
        console.log('ẻeeeee', res)
      } else {
        console.error('No data found or invalid response')
      }
    } catch (err) {
      openNotification('error', err?.response?.data?.message || 'Đã có lỗi xảy ra')
    }
  }

  // Danh sách sàn
  const getDepartmentAll = async (values) => {
    let {
      name = '',
      type = '',
      page = 1,
      department_id = '',
      pageSize = 1000
    } = values || {}
    try {
      const body = { name, type, page, pageSize, department_id }
      const res = await departmentSearch(body)
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.id,
        label: item.name
      }))
      setListDepartment(result)
    } catch (err) {
      openNotification('error', err?.response?.data?.message || 'Đã có lỗi xảy ra')
    }
  }

  // Danh sách tài khoản theo SÀN
  const getUserAll = async () => {
    let page = 1
    let pageSize = 1000
    const deId = localStorage.getItem('department_id')
    const user_role = localStorage.getItem('user_role')
    try {
      let body = {}
      if (user_role == 'ADMIN') {
        body = {
          page,
          pageSize,
        }
      } else {
        body = {
          page,
          pageSize,
          department_id: deId
        }
      }
      const res = await getListStaff(body) // Assuming roleSearch is an API function
      if (res && res?.data?.list) {
        const result = res?.data?.list.map((item) => ({
          ...item,
          value: item.id,
          label: item.name
        }))
        setListUser(result) // Update the state with the list of roles
      } else {
        // Handle the case where the response is unexpected or empty
        console.error('No data found or invalid response')
        setListUser([]) // Optionally, reset the list to an empty array
      }
    } catch (err) {
      // Handle the error gracefully
      openNotification('error', err?.response?.data?.message || 'Đã có lỗi xảy ra')
      // You might want to show a notification or alert to the user here
      setListUser([]) // Optionally, reset the list to an empty array
    }
  }

  // Danh sách dự án
  const getProjectAll = async (values) => {
    let { page = 1, pageSize = 1000 } = values || {}
    try {
      const body = { page, pageSize }
      const res = await projectSearch(body)
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.id,
        label: item.project_name
      }))

      setListProject(result)
    } catch (err) {
      openNotification('error', err?.response?.data?.message || 'Đã có lỗi xảy ra')
    }
  }
  // Danh sách thành phố
  const getListCities = async () => {
    try {
      const res = await addressSearch('', 'city')
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.code,
        label: item.name
      }))

      setCities(result)
    } catch (err) {
      openNotification('error', err?.response?.data?.message || 'Đã có lỗi xảy ra')
    }
  }

  // Danh sách quận huyện
  const getListDistricts = async (code) => {
    // const code = cities.filter((item) => item.id == i)?.[0].code
    const params = {
      parent_code: code
    }
    try {
      const res = await addressSearch(params, 'district')
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.code,
        label: item.name
      }))
      setDistricts(result)
    } catch (err) {
      openNotification('error', err?.response?.data?.message || 'Đã có lỗi xảy ra')
    }
  }

  // Danh sách phường xã
  const getListTowns = async (code) => {
    // const type = 'town'
    const params = {
      parent_code: code
    }
    try {
      const res = await addressSearch(params, 'town')
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.code,
        label: item.name
      }))
      setTowns(result)
    } catch (err) {
      openNotification('error', err?.response?.data?.message || 'Đã có lỗi xảy ra')
    }
  }

  useEffect(() => {
    getUserAll()
    getProjectAll()
    getListCities()
  }, [])

  useEffect(() => {
    const user_role = localStorage.getItem('user_role')
    const department_id = localStorage.getItem('department_id')
    if (user_role === 'ADMIN') {
      getDepartmentAll()
    } else {
      getDepartmentAll(department_id)
    }
  }, [])

  // func
  const onChangeProject = async (value) => {
    const dataProject = _.find(listProject, (el) => el.id === value)

    // const codeCity = cities.filter((item) => item.code == dataProject.city)?.[0]
    //   ?.id
    await getListDistricts(dataProject?.city_code)
    await getListTowns(dataProject?.district_code)

    form.setFieldsValue({
      city_code: dataProject?.city_code ? dataProject.city_code : null,
      district_code: dataProject?.district_code ? dataProject.district_code : null,
      town_code: dataProject?.town_code ? dataProject.town_code : null,
      street: dataProject?.address ? dataProject.address : null,
      project_name: dataProject?.project_name ? dataProject.project_name : null
    })
  }

  // Chọn city hay district thì call api
  const onChangeCity = (e) => {
    getListDistricts(e)
    form.setFieldsValue({
      district_code: null,
      town_code: null
    })
  }
  const onChangeDistrict = (e) => {
    const code = districts.filter((item) => item.code == e)?.[0]?.code

    getListTowns(code)
    form.setFieldsValue({
      town_code: null
    })
  }

  const onChangeDepartment = async (value) => {
    await getUserAll(value)

    form.setFieldsValue({
      manager_post_id: null
    })
  }

  const genBedroomNumber = (number_of_floor) => {
    return find(BedroomNumber, (el) => el?.value == number_of_floor)?.label
  }

  // Kiểm tra loại file & dung lượng
  // const beforeUpload = (file) => {
  //   const isImage = file.type.startsWith('image/')
  //   if (!isImage) {
  //     message.error('Chỉ được phép upload file ảnh!')
  //   }

  //   const isLt2M = file.size / 1024 / 1024 < 2
  //   if (!isLt2M) {
  //     message.error('Ảnh phải nhỏ hơn 2MB!')
  //   }

  //   return isImage && isLt2M
  // }

  // Xử lý khi upload thay đổi

  const handleCancel = () => {
    setPreviewVisible(false)
  }

  const handlePreview = async (file) => {
    if (file.response) {
      setPreviewImage(file.response?.[0]?.link)
      setPreviewVisible(true)
      setPreviewTitle(false)
    } else {
      setPreviewImage(file.url)
      setPreviewVisible(true)
      setPreviewTitle(false)
    }
  }

  const [totalSize, setTotalSize] = useState(0) // Lưu tổng dung lượng video & 360 (MB)

  const handleCustomRequest = async (options, type) => {
    const { file, onSuccess, onError, onProgress } = options

    // Tạo FormData và append file vào formData
    const formData = new FormData()
    type == 'image'
      ? formData.append('file_image', file)
      : type == 'video'
      ? formData.append('file_video', file)
      : formData.append('file_360', file)

    try {
      // Gọi API upload thông qua hàm upLoadImage
      const response = await upLoadImage(formData)
      // Nếu có tiến trình upload, bạn có thể gọi onProgress
      if (onProgress) {
        onProgress({ percent: 100 })
      }
      // Gọi onSuccess của Upload để thông báo upload thành công
      onSuccess(response.data, file)

      // 👉 Nếu là video hoặc 360 thì tính dung lượng
      if (type === 'video' || type === '360') {
        const fileSizeMB = file.size / 1024 / 1024 // Chuyển Byte -> MB
        setTotalSize((prevSize) => prevSize + fileSizeMB)
      }

      // message.success(`${file.name} upload thành công!`)
    } catch (error) {
      const err = error?.response?.data?.message || ''
      openNotification('error', err || 'upload thất bại')
      onError(error)
    }
  }

  const handleChange = (info, type) => {
    let newFileList = [...info.fileList]

    // Chỉ cập nhật fileList nếu không có lỗi
    newFileList = newFileList.filter((file) => {
      if (file.status == 'error') {
        message.error(`Upload thất bại: ${file.name}`)
      }
      return file.status !== 'error'
    })
    type == 'image'
      ? setFileList(newFileList)
      : type == 'video'
      ? setFileListVideo(newFileList)
      : setFileList360(newFileList)
  }
  const getListHistory = async (id) => {
    const params = {
      from: 5
    }
    const types = [3, 6, 7, 8, 2]
    if (Array.isArray(types)) {
      types.forEach(type => {
        params[`type`] = type
      })
    }
    const res = await listHistory(params, id)
    console.log('res', res)
  }
  return (
    <div>
      <Loading loading={loading} />
      <Card className="mb-2">
        <FilterForm
          form={formSearch}
          getListPost={getListPost}
          listDepartment={listDepartment}
          listProject={listProject}
          cities={cities}
          districts={districts}
          towns={towns}
          user={listUser}
          onChangePostType={onChangePostType}
          listTypeRealEstate={typeRealEstate}
          onChangeCity={onChangeCity}
          onChangeDistrict={onChangeDistrict}
          onChangeDepartment={onChangeDepartment}
          pagination={pagination}
          setPagination={setPagination}
        />
      </Card>

      <Card>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            margin: '0px 50px 10px 0px',
            width: '100%'
          }}
        >
          {/* <h2 className="text-2xl font-semibold my-2">Quản lý tin BĐS nội bộ</h2> */}
          <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px' }}>
            <ExportButton
              columns={initialColumns}
              data={data?.list}
              fileName="Quan_ly_tin_nhanh"
              sheetName="Tin nhanh"
              permission="P79.1"
            />
            {hasPermission('P39.5', permissions) && (
              <Button
                danger
                // disabled={selectedRowKeys.length > 0 ? false : true}
                type="primary"
              onClick={() => {
                if (selectedRowKeys.length == 0) {
                  openNotification('error', 'Vui lòng chọn tin')
                } else {
                  showConfirm({
                    title: 'Xác nhận xoá',
                    content: (
                      <div>
                        Bạn có chắc chắn muốn xoá{' '}
                        <b>{selectedRowKeys?.length}</b> tin không?
                      </div>
                    ),
                    onOk: () => deleteRequest(selectedRowKeys)
                  })
                }
              }}
            >
              <DeleteOutlined />
                Xoá
              </Button>
            )}
            {/* <Button
              type="primary"
              // htmlType="submit"
              onClick={() => {
                if (selectedRowKeys.length == 0) {
                  openNotification('error', 'Vui lòng chọn yêu cầu')
                } else {
                  setIsModalManagerRequest(true)
                }
              }}
            >
              <DiffOutlined />
              Chọn quản lý
            </Button> */}
          </div>
        </div>
        <TableField
          loading={loading}
          columns={initialColumns}
          data={data?.list}
          scroll={{ x: data?.list?.length > 0 ? 'max-content' : '100%', y: 'calc(100vh - 400px)' }}
          className={`custom-table`}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: data?.total,
            pageSizeOptions: PAGE_SIZE_OPTIONS,
            showSizeChanger: true,
            onChange: handlePageChange,
            showTotal: (total, range) => `Hiển thị ${range[0]}-${range[1]} của ${total} bản ghi`
          }}
          rowKey="id"
          locale={{
            emptyText: <Empty description="Không có dữ liệu" />, // Hiển thị "Không có dữ liệu" khi bảng không có dữ liệu
            triggerDesc: 'Sắp xếp giảm dần', // Khi click vào cột để sort giảm dần
            triggerAsc: 'Sắp xếp tăng dần', // Khi click vào cột để sort tăng dần
            cancelSort: 'Hủy sắp xếp' // Khi bỏ sắp xếp
          }}
          rowSelection={{
            selectedRowKeys: selectedRowKeys, // Mảng chứa các row được chọn
            onChange: (selectedKeys) => setSelectedRowKeys(selectedKeys), // Xử lý khi chọn row
            type: 'checkbox', // Hoặc 'radio' nếu chỉ chọn được 1
            preserveSelectedRowKeys: true // Giữ selection khi phân trang
          }}
        />
      </Card>
      {/* Modal Thêm mới sản phẩm */}
      <ModalCustom
        title={
          mode == ACTION_MODE.UPDATE
            ? 'Chỉnh sửa tin nhanh'
            : 'Thêm mới tin nhanh'
        }
        visible={isModalOpen}
        // visible={isModalOpen}
        centered
        width={1200}
        // className="modal-bond"
        onCancel={() => {
          setIsModalOpen(false)
          form.resetFields()
          // setFileImage([])
          // setFile360([])
          // setFileVideo([])
          setFileList([])
          setFileListVideo([])
          setFileList360([])
        }}
        onConfirm={async () => {
          try {
            await form.validateFields() // Kiểm tra validation trước khi tiếp tục
            handleSave() // Nếu hợp lệ thì tiếp tục xử lý
          } catch (error) {
            console.log('Validation failed:', error)
            if (error?.errorFields?.length > 0) {
              form.scrollToField(error.errorFields[0].name, {
                behavior: "smooth",
                block: "center", // Đảm bảo label không bị che
              });
            }
          }
        }}
        confirmText={'Lưu'}
        cancelText="Đóng"
      >
        {/* <FormPost
          form={form}
          handleSearch={handleSearch}
          listDepartment={listDepartment}
          listUser={listUser}
          LabelType={LabelType}
          ProductType={ProductType}
          typeRealEstate={typeRealEstate}
          listProject={listProject}
          cities={cities}
          districts={districts}
          towns={towns}
          postType={postType}
          fileList={fileList}
          handleCustomRequest={handleCustomRequest}
          handleChange={handleChange}
          handlePreview={handlePreview}
          previewVisible={previewVisible}
          previewTitle={previewTitle}
          handleCancel={handleCancel}
          onChangeProject={onChangeProject}
          previewImage={previewImage}
          onChangePostType={onChangePostType}
          onChangeCity={onChangeCity}
          onChangeDistrict={onChangeDistrict}
          fileListVideo={fileListVideo}
          fileList360={fileList360}
          onChangeDepartment={onChangeDepartment}
          totalSize={totalSize}
          mode={mode}
          setFileList360={setFileList360}
          setIsText={setIsText}
          isText={isText}
          loading={loading}
          setLoading={setLoading}
          getListUserPost={getListUserPost}
        /> */}
        <FormPost
          form={form}
          handleSearch={handleSearch}
          listDepartment={listDepartment}
          listUser={listUserDepartment}
          LabelType={LabelType}
          ProductType={ProductType}
          typeRealEstate={typeRealEstate}
          listProject={listProject}
          cities={cities}
          districts={districts}
          towns={towns}
          postType={postType}
          fileList={fileList}
          handleCustomRequest={handleCustomRequest}
          handleChange={handleChange}
          handlePreview={handlePreview}
          previewVisible={previewVisible}
          previewTitle={previewTitle}
          handleCancel={handleCancel}
          onChangeProject={onChangeProject}
          previewImage={previewImage}
          onChangePostType={onChangePostType}
          onChangeCity={onChangeCity}
          onChangeDistrict={onChangeDistrict}
          fileListVideo={fileListVideo}
          fileList360={fileList360}
          onChangeDepartment={onChangeDepartment}
          totalSize={totalSize}
          mode={mode}
          setFileList360={setFileList360}
          setIsText={setIsText}
          isText={isText}
          getListPost={getListPost}
          recordId={recordId}
        />
      </ModalCustom>  
      <ModalConfirm />

      <ModalCustom
        title="Danh sách quản lý note"
        visible={isModalNote}
        centered
        width={600}
        onCancel={() => {
          setIsModalNote(false)
        }}
        confirmText={'Lưu'}
        cancelText="Đóng"
        footer={''}
      >
        <Note postId={recordId} getListPost={getListPost}/>
      </ModalCustom>

      <HistoryModal 
      id={recordId} 
      isOpen={isOpenCall} 
      setIsOpen={setIsOpenCall} 
      listDepartment={listDepartment}
      cities={citiesAll}
      districts={districtsAll}
      towns={townsAll}
      />
    </div>
  )
}

export default BreakingNews
